/**
 * authfack.js — Vuex module: LEGACY auth (deprecated)
 *
 * ⚠️  JANGAN DIPAKAI UNTUK FITUR BARU.
 *
 * Module ini ada hanya untuk backward compatibility dengan kode lama yang
 * masih reference 'authfack/login' atau 'authfack/logout'. Semua auth logic
 * baru wajib lewat module 'auth' (lihat src/state/modules/auth.js).
 *
 * Fungsi (legacy):
 * - menyimpan state user yang login (tanpa token, hanya status & user object)
 * - delegate login/logout ke authService yang sama dengan module 'auth'
 *
 * API (lewat authService):
 * - POST /auth/login   (action `login`)
 * - POST /auth/logout  (action `logout`)
 *
 * Suatu saat module ini akan dihapus setelah semua kode lama sudah migrate
 * ke module 'auth'.
 */
// This module exists for backward compatibility only.
// All auth logic now goes through the 'auth' module.
import { authService } from '../../helpers/authservice/auth.service';
import router from '../../router/index';

const storedUser = authService.getCurrentUser();
const storedToken = authService.getToken();

export const state = storedUser && storedToken
  ? { status: { loggeduser: true }, user: storedUser }
  : { status: {}, user: null };

export const actions = {
  // Delegate login to auth module
  async login({ dispatch, commit }, { email, password }) {
    commit('loginRequest', { email });
    try {
      const { token, user } = await authService.login(email, password);
      if (token) {
        commit('loginSuccess', user);
        router.push('/');
      } else {
        const errorMsg = 'Login gagal. Cek kembali email dan password Anda.';
        commit('loginFailure', errorMsg);
        dispatch('notification/error', errorMsg, { root: true });
      }
    } catch (error) {
      let errorMsg = 'Login gagal. Terjadi kesalahan.';
      if (error.response) {
        const data = error.response.data;
        errorMsg = data.message || data.error || data.data || errorMsg;
        if (data.errors) {
          const firstError = Object.values(data.errors)[0];
          errorMsg = Array.isArray(firstError) ? firstError[0] : firstError;
        }
      }
      commit('loginFailure', errorMsg);
      dispatch('notification/error', errorMsg, { root: true });
    }
  },

  async logout({ commit }) {
    await authService.logout();
    commit('logout');
  },
};

export const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggeduser: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
};
